import React, { useEffect, useState } from 'react';
import { BadgeCheck, Calendar, Tag, Trophy } from 'lucide-react';
import appDataService, { Series } from '../services/appDataService';
import ListingExplorer, {
  ListingBadge,
  ListingFilterDef,
  ListingItem,
} from '../components/listings/ListingExplorer';

const FILTERS: ListingFilterDef[] = [
  {
    key: 'verified',
    label: 'Verifiziert',
    icon: BadgeCheck,
    test: (i) => (i as Series).verified === true,
  },
  {
    key: 'withTournaments',
    label: 'Mit Turnieren',
    icon: Calendar,
    test: (i) => {
      const s = i as Series;
      return Array.isArray(s.tournaments) && s.tournaments.length > 0;
    },
  },
];

const badgesFor = (item: ListingItem): ListingBadge[] => {
  const series = item as Series;
  const badges: ListingBadge[] = [];
  if (series.verified) {
    badges.push({ key: 'verified', label: 'Verifiziert', icon: BadgeCheck });
  }
  if (Array.isArray(series.tournaments) && series.tournaments.length > 0) {
    badges.push({
      key: 'tournaments',
      label: `${series.tournaments.length} ${series.tournaments.length === 1 ? 'Turnier' : 'Turniere'}`,
      icon: Calendar,
    });
  }
  (series.categories || []).slice(0, 2).forEach((cat, idx) => {
    if (cat && typeof cat === 'string' && cat.trim()) {
      badges.push({ key: `cat-${idx}`, label: cat.trim(), icon: Tag });
    }
  });
  return badges;
};

const searchTextFor = (item: ListingItem): string => {
  const series = item as Series;
  return [
    series.description || '',
    ...(series.categories || []),
    ...(series.tags || []),
  ].join(' ');
};

const SeriesPage: React.FC = () => {
  const [series, setSeries] = useState<Series[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    appDataService
      .getSeries()
      .then((data) => {
        if (!cancelled) setSeries(Array.isArray(data) ? data : []);
      })
      .catch(() => {
        if (!cancelled) setSeries([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <ListingExplorer
      items={series}
      loading={loading}
      title="Turnierserien"
      subtitle="Regelmäßig werfen, Punkte sammeln, aufsteigen: Entdecke Ligen und Turnierserien in deiner Region."
      searchPlaceholder="Serie, Ort oder Kategorie suchen..."
      emptyIcon={Trophy}
      fallbackIcon={Trophy}
      emptyLabel="Keine Turnierserien gefunden"
      routeBase="/turnierserie"
      filters={FILTERS}
      badges={badgesFor}
      searchText={searchTextFor}
      countLabel="Turnierserien"
      countLabelSingular="Turnierserie"
      seoTitle="Turnierserien & Dart-Ligen | DartCloud"
      seoDescription="Entdecke regelmäßige Dart-Turnierserien, Ligen und Events in deiner Nähe auf DartCloud."
    />
  );
};

export default SeriesPage;
